import React, {FC} from 'react'
import {SellersListWrapper} from './sellers-list/sellersList'

const SellersPageWrapper: FC = () => {
  return (
    <>
      <SellersListWrapper />
    </>
  )
}

export default SellersPageWrapper
